import React from "react";
import logo from "./logo.svg";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./assets/fonts/style.css";

import AboutUsPage from "./pages/About/about_us_page"
import OurCompany from "./pages/About/our_company/index"
import Awards from "./pages/About/awards"
import Leadership from "./pages/About/leadership"
import Blog from "./pages/About/blog"
import Service from "./pages/Service";
import CareersPage from "./pages/Careers/index";
import ParkerStorePage from "./pages/Parker/parker_store";
import ContactUsPage from "./pages/Contact/index";
import HeaderComponent from "./components/header_component";
import FluidConnector from "./pages/About/blog/FluidConnector/index";

import Home from "./pages/Home";

function App() {
  return (
    <Router>
      {/* <Header /> */}
      <HeaderComponent />
      {/*<Layout>*/}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/about/our-company" element={<OurCompany />} />
        <Route path="/about/awards" element={<Awards />} />
        <Route path="/about/leadership" element={<Leadership />} />
        <Route path="/about/blog" element={<Blog />} />
        <Route path="/about/blog/fluid-connector/:id" element={<FluidConnector />} />

        <Route path="/products" element={<Service />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/parkerStore" element={<ParkerStorePage />} />
        <Route path="/contactUs" element={<ContactUsPage />} />
      </Routes>
      {/* </Layout>*/}
    </Router>
  );
}

export default App;
